import * as React from "react";
import { useState } from "react";
import { Center, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  EstimatedPurchasedGoodsAndServicesTab,
  PurchasedGoodsAndServicesTab,
  WaterUsageAndTreatmentTab
} from "./components";
import { translateSubElementString } from "../../../../../../../../utils";
import { NumberField } from "../../../../../../../../components/NumberField";
import CategoryPreviewWrapper from "../CategoryPreviewWrapper";

function PurchasedGoodsAndServicesPreview({ currentElement, reportId }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThree.inputs.purchasedGoodsAndServices.tabs"
  });
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <CategoryPreviewWrapper>
      <Flex marginBlockEnd={4}>
        <Text size="sm" fontWeight="bold">
          {translateSubElementString(
            "reportsPage.scopeThree.inputs.mainTotalEmissions"
          )}
        </Text>
        <NumberField value={currentElement?.totalCo2Emissions ?? ""} marginStart="2" />
      </Flex>
      <Tabs
        colorScheme="customScheme"
        index={tabIndex}
        onChange={setTabIndex}
        marginBlockStart="4"
        height="calc(100% - var(--chakra-space-12))"
        overflow="auto"
      >
        <Center>
          <TabList borderBottom="none" marginBottom="4">
            <Tab _focus={{ boxShadow: "none" }}>{t("waterUsageAndTreatmentTab")}</Tab>
            <Tab _focus={{ boxShadow: "none" }}>{t("estimatedPurchasedGoodsAndServicesTab")}</Tab>
            <Tab _focus={{ boxShadow: "none" }}>{t("supplierProvidedEmissionsTab")}</Tab>
          </TabList>
        </Center>
        <TabPanels maxHeight="100%">
          <TabPanel padding="0">
            <WaterUsageAndTreatmentTab data={currentElement} />
          </TabPanel>
          <TabPanel padding="0">
            <EstimatedPurchasedGoodsAndServicesTab data={currentElement} reportId={reportId} />
          </TabPanel>
          <TabPanel padding="0">
            <PurchasedGoodsAndServicesTab data={currentElement} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </CategoryPreviewWrapper>
  );
}

export default PurchasedGoodsAndServicesPreview;